// SVG Component Props
interface SVGComponentProps {
  className?: string;
}
export const Plus: React.FC<SVGComponentProps> = ({ className }) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0006 20V4M4 12H20" stroke="#1F1F1F" strokeWidth="2" strokeLinecap="square"/>
    </svg>
  );
};
